import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CloseButtonSvgIcon } from './IconProvider';
import { Alert } from '../../services/notiflix.service';
import { useState } from 'react';
import ProjectsService from '../../services/projects.service';
export const ContactMeModal = ({
  projectDetails,
  setTransactionPop,
  setShowThankYouPopup,
  paymentStatus,
}) => {
  const { t } = useTranslation(['projectDetails', 'common']);
  const navigate = useNavigate();
  const [userNote, setUserNote] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChangeInfo = () => {
    navigate('/profile?redirect=contact-popup', {
      state: {
        id: projectDetails?.id,
        openContactPopup: true,
        quantity: paymentStatus?.quantity,
        paymentMethod: paymentStatus?.payment_method,
        slug: 'contactUs',
      },
    });
  };

  const handleSendContactMail = async () => {
    setLoading(true);
    try {
      const payload = {
        user_name: _authUser?.userName,
        email: _authUser?.email,
        phoneNumber: _authUser?.phoneNumber,
        note: userNote,
        quantity: paymentStatus?.quantity || '',
        paymentMethod: 'Bank Transfer',
        projectName: projectDetails?.name || '',
        symbol: projectDetails?.symbol,
      };

      const resp =
        await ProjectsService.purchaseConfirmationEmailRequest(payload);

      if (resp.status === 'failure') {
        setTransactionPop(false);
        Alert.error(resp.message);
        return false;
      }
      setTransactionPop(false);
      setShowThankYouPopup(true);
    } catch (error) {
      Alert.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const { user: _authUser } = useSelector((state) => state.auth);
  return (
    <div className="fixed w-full h-full flex justify-center items-start bg-black bg-opacity-50 pt-[127px] left-0 top-0 z-30 px-4 overflow-y-auto">
      <div className="w-[800px] bg-white rounded-[30px] p-12 shadow-md relative z-40 text-[#0B243F]">
        <button
          className="absolute top-4 right-4 z-50"
          onClick={() => setTransactionPop(false)}
        >
          <span className="w-8 h-8 flex items-center justify-center dark:bg-slate-300 rounded-md">
            <CloseButtonSvgIcon />
          </span>
        </button>

        <h3 className="text-2xl font-semibold mb-4">{t('contact_title')}</h3>
        <p className="text-lg text-gray-700 mb-6">{t('contact_description')}</p>

        <div className="text-[18px] font-semibold leading-[27px] mb-[15px]">
          {t('contact_contact_info')}
        </div>

        <div className="text-[16px] font-normal leading-[14px] text-gray-800 mb-[15px]">
          {_authUser?.userName || 'N/A'}
        </div>
        <div className="text-[16px] font-normal leading-[14px] text-gray-800 mb-[15px]">
          {_authUser?.phoneNumber || 'N/A'}
        </div>
        <div className="text-[16px] font-normal leading-[14px] text-gray-800">
          {_authUser?.email || 'N/A'}
        </div>

        <div className="text-sm mt-3 mb-8">
          <p>
            {t('contact_incorrect')}{' '}
            <button
              onClick={handleChangeInfo}
              className="ml-[-15px] text-blue-600 font-medium hover:text-blue-800"
            >
              {t('contact_change_it_here')}
            </button>
          </p>
        </div>
        <div className="mb-6">
          <label className="block text-sm font-medium mb-2">
            {t('contact_note_label')}
          </label>
          <textarea
            rows={4}
            placeholder={t('contact_note_placeholder')}
            value={userNote}
            onChange={(e) => setUserNote(e.target.value)}
            className="w-full border border-gray-500 rounded-md p-3 text-sm text-gray-700 resize-none focus:outline-none focus:ring-2 focus:ring-[#A7D760]"
          />
        </div>

        <div className="flex justify-end">
          <button
            onClick={handleSendContactMail}
            disabled={loading}
            className="bg-[#A7D760] hover:bg-[#97C05B] active:bg-[#8DB158] text-[#0B243F] text-base font-semibold rounded-md transition-all disabled:opacity-50"
          >
            {loading ? t('contact_sending') : t('contact_me')}
          </button>
        </div>
      </div>
    </div>
  );
};
